import type { GraphQLError } from 'graphql';

import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseDataRetentionDetailsQuery, {
	type useDataRetentionDetailsQuery$data,
	type useDataRetentionDetailsQuery$variables,
} from '../hooks/__generated__/useDataRetentionDetailsQuery.graphql.ts';

interface PreloadDataRetentionQueryI {
	cloudId: string;
}

export const preloadDataRetentionPolicy = async ({
	cloudId,
}: PreloadDataRetentionQueryI): Promise<
	| {
			data: useDataRetentionDetailsQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }
	| undefined
> => {
	if (!cloudId || !fg('dlp-dlm-data-retention-policy')) {
		return;
	}

	return query<useDataRetentionDetailsQuery$data, useDataRetentionDetailsQuery$variables>({
		query: UseDataRetentionDetailsQuery,
		variables: { cloudId },
		errorPolicy: 'all',
	});
};
